import axios from "axios";

const state = {
  single_Opportunity_Details: "",
  all_Opportunity_Details: "",
  current_page: 0,
  per_page: 0,
  total: 0,
  totalPages: 0,
  fromItem: 0,
  toItem: 0,
  loadingPageButton: 0,

  // 🔥 New additions
  search: "",
  filterOptions: {
    open: false,
    won: false,
    lost: false,
  },
};

const mutations = {
  SET_OPPORTUNITY_DETAILS(state, data) {
    state.single_Opportunity_Details = data;
  },
  SET_ALL_OPPORTUNITY_DETAILS(state, data) {
    console.log('SET_ALL_OPPORTUNITY_DETAILS---', data);
    
    state.all_Opportunity_Details = data?.data;
    state.current_page = data?.current_page;
    state.per_page = data?.per_page;
    state.total = data?.total;
    state.totalPages = data?.last_page;
    state.fromItem = data?.from;
    state.toItem = data?.to;
  },
  SET_SEARCH(state, value) {
    state.search = value;
  },
  SET_FILTER_OPTIONS(state, payload) {
    state.filterOptions = { ...state.filterOptions, ...payload };
  },
};

const actions = {
  GetOpportunityByID({ commit, rootGetters }, Id) {
    commit("SET_TOTAL_APIS", 1);
    return new Promise((resolve, reject) => {
      axios
        .get(axios.defaults.baseURL + "opportunity/" + Id, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          commit("SET_OPPORTUNITY_DETAILS", res.data.data[0]);
          const G_Total_Apis = rootGetters["G_Total_Apis"];
          var G_Completed_APICalls = rootGetters["G_Completed_APICalls"];
          G_Completed_APICalls++;
          const progress = (G_Completed_APICalls / G_Total_Apis) * 100;
          commit("SET_PROGRESS", progress);
          commit("SET_COMPLETED_APIS", G_Completed_APICalls);
          resolve(res.data.data[0]);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },

  async Get_Opportunites({ commit, rootGetters, state }, page = 1) {
    commit("SET_TOTAL_APIS", 1);
    try {
      const statusList = [];
      if (state.filterOptions.open) statusList.push("open");
      if (state.filterOptions.won) statusList.push("won");
      if (state.filterOptions.lost) statusList.push("lost");

      const params = new URLSearchParams();
      params.append("page", page);
      if (state.search) params.append("search", state.search);
      if (statusList.length > 0) params.append("status", statusList.join(","));

      const res = await axios.get(
        `${axios.defaults.baseURL}opportunities?${params.toString()}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      commit("SET_ALL_OPPORTUNITY_DETAILS", res.data.data);

      const G_Total_Apis = rootGetters["G_Total_Apis"];
      var G_Completed_APICalls = rootGetters["G_Completed_APICalls"];
      G_Completed_APICalls++;
      const progress = (G_Completed_APICalls / G_Total_Apis) * 100;
      commit("SET_PROGRESS", progress);
      commit("SET_COMPLETED_APIS", G_Completed_APICalls);
    } catch (err) {
      console.error("Error in Get_Opportunites:", err);
    }
  },
};

const getters = {
  getSearch: (state) => state.search,
  getFilterOptions: (state) => state.filterOptions,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
